<template>
<div class="capital">
    <router-view :param="param"></router-view>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'

export default {
    name: 'capital',
    mixins: [initPage],
    data() {
        return {
            param: {
                eventinnerid: '',
                status: ''
            }
        }
    },
    mounted() {
        this.setParams(this._.cloneDeep(this.param))
    },
    methods: {
        ...mapActions([
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.capital {
    .el-icon-info{
        margin: 0 !important;
    }
}
</style>
